module.exports = __webpack_public_path__ + "static/media/IntroFlagpole.9a777adb.svg";